import { ReactNode } from 'react'

export const Base = (props: { children: ReactNode | ReactNode[] }) => {
  const { children = [] } = props

  return <>{children}</>
}
